import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const AccordionBlock = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const testId = `accordion-${title.toLowerCase().replace(/[\s/:?]+/g, '-').slice(0, 40)}`;

  return (
    <div data-testid={testId} className="rounded-xl border border-black/[0.07] overflow-hidden bg-white">
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50/80 transition-colors"
      >
        <span className="font-semibold text-ink text-[15px] leading-snug pr-3">{title}</span>
        <ChevronDown
          size={16}
          className={`text-ink-secondary transition-transform shrink-0 ${open ? 'rotate-180' : ''}`}
        />
      </button>
      {open && (
        <div className="px-5 pb-5 pt-2 bg-gray-50/60 border-t border-black/[0.05]">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionBlock;
